export const GoogleEventsKeys = {
  VerifyIdentityPageLoad: "UploadMedDoc_Step 1_verify-identity",
  VerifyIdentityNext: "UploadMedDoc_Step 1_next",
  UploadFilesPageLoad: "UploadMedDoc_Step 2_upload-files-page",
  UploadFilesSubmit: "UploadMedDoc_Step 2_submit",
  UploadFilesSubmitSuccess: "UploadMedDoc_Step 2_submit-success",
  UploadFilesSubmitFailed: "UploadMedDoc_step 2_upload-failed",
  ExpiredLinkPageLoad: "UploadMedDoc_expired-page",
  ExpiredLinkRequestNewLink: "UploadMedDoc_expired-request-new-link",
  ExpiredSessionPromptShown: "UploadMedDoc_expired-session-prompt",
  ClosedLinkPageLoad: "UploadMedDoc_closed-link-message",
  LinkNotFoundPageLoad: "UploadMedDoc_link-not-found-message"
}
